import Link from "next/link";
import { redirect } from "next/navigation";

import { auth } from "@/auth";
import { prisma } from "@/lib/prisma";

import ProductForm from "../product-form";

export default async function NewAdminArticlePage() {
  const session = await auth();

  if (!session?.user) {
    redirect("/connexion?callbackUrl=/admin/articles/nouveau");
  }

  if (session.user.role !== "ADMIN") {
    redirect("/compte");
  }

  const categories = await prisma.category.findMany({
    orderBy: {
      name: "asc",
    },
    select: {
      id: true,
      name: true,
    },
  });

  return (
    <div className="space-y-4 md:space-y-6">
      <section className="overflow-hidden rounded-[2rem] border border-[#f2d7e4] bg-[linear-gradient(135deg,#fff8fb_0%,#fffdfa_58%,#fdf4f7_100%)] shadow-[0_20px_80px_rgba(196,78,124,0.08)]">
        <div className="grid gap-8 px-6 py-7 sm:px-8 sm:py-8 xl:grid-cols-[minmax(0,1.4fr)_320px] xl:items-end">
          <div className="space-y-5">
            <div className="hidden">
              <Link
                href="/admin/articles"
                className="font-[family-name:var(--font-ibm-plex-mono)] uppercase tracking-[0.2em] transition hover:text-[#6f324e]"
              >
                Articles
              </Link>
              <span>/</span>
              <span className="font-[family-name:var(--font-ibm-plex-mono)] uppercase tracking-[0.2em] text-[#b64678]">
                Nouveau
              </span>
            </div>

            <span className="inline-flex w-fit items-center rounded-full border border-[#efc7d9] bg-white/80 px-3 py-1 font-[family-name:var(--font-ibm-plex-mono)] text-[11px] uppercase tracking-[0.24em] text-[#b64678] backdrop-blur">
              Studio admin
            </span>

            <div className="space-y-3">
              <h1 className="text-3xl font-semibold tracking-[-0.04em] text-[#24161d] sm:text-5xl">
                Ajouter un article
              </h1>
              <p className="max-w-2xl text-sm leading-7 text-[#6f5a63] sm:text-base">
                Un espace plus éditorial pour imaginer une nouvelle fiche
                produit, poser ses informations essentielles et enrichir le
                catalogue Jour J avec cohérence.
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                href="/admin/articles"
                className="inline-flex items-center justify-center rounded-full border border-[#efc7d9] bg-white/80 px-5 py-3 text-sm font-medium text-[#6f324e] transition hover:border-[#e3a9c5] hover:bg-white"
              >
                Retour à la liste
              </Link>
              <Link
                href="/admin/articles"
                className="inline-flex items-center justify-center rounded-full bg-[#d85c92] px-5 py-3 text-sm font-medium text-white shadow-[0_14px_34px_rgba(216,92,146,0.24)] transition hover:bg-[#c94b82]"
              >
                Commencer la fiche
              </Link>
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-3 xl:grid-cols-1">
            <div className="rounded-[1.6rem] border border-white/80 bg-white/75 p-5 shadow-[0_12px_30px_rgba(36,22,29,0.05)] backdrop-blur">
              <p className="font-[family-name:var(--font-ibm-plex-mono)] text-[11px] uppercase tracking-[0.22em] text-[#a88495]">
                Phase
              </p>
              <p className="mt-3 text-2xl font-semibold tracking-[-0.05em] text-[#24161d]">
                Nouveau
              </p>
            </div>

            <div className="rounded-[1.6rem] border border-white/80 bg-white/75 p-5 shadow-[0_12px_30px_rgba(36,22,29,0.05)] backdrop-blur">
              <p className="font-[family-name:var(--font-ibm-plex-mono)] text-[11px] uppercase tracking-[0.22em] text-[#a88495]">
                Statut
              </p>
              <p className="mt-3 text-2xl font-semibold tracking-[-0.05em] text-[#24161d]">
                Brouillon
              </p>
            </div>

            <div className="rounded-[1.6rem] border border-white/80 bg-white/75 p-5 shadow-[0_12px_30px_rgba(36,22,29,0.05)] backdrop-blur">
              <p className="font-[family-name:var(--font-ibm-plex-mono)] text-[11px] uppercase tracking-[0.22em] text-[#a88495]">
                Visibilité
              </p>
              <p className="mt-3 text-2xl font-semibold tracking-[-0.05em] text-[#24161d]">
                Privée
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="rounded-[2rem] border border-[#f0dfe7] bg-[#fffdfb] p-5 shadow-[0_12px_40px_rgba(36,22,29,0.04)] sm:p-6">
        <div className="mb-5 flex flex-col gap-2">
          <p className="font-[family-name:var(--font-ibm-plex-mono)] text-[11px] uppercase tracking-[0.22em] text-[#b38a9d]">
            Édition produit
          </p>
          <h2 className="text-2xl font-semibold tracking-[-0.04em] text-[#24161d]">
            Construire la fiche
          </h2>
        </div>

        <ProductForm mode="create" categories={categories} />
      </div>
    </div>
  );
}